import { NgModule } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { OperationTypeNode } from 'graphql';
import { omitDeep } from 'lodash-omitdeep';
import { environment } from 'src/environments/environment';

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory(httpLink: HttpLink) {
        const removeTypeNameFromMutation = new ApolloLink((operation, forward) => {
          const definition = operation?.query?.definitions.filter(def => def.kind === 'OperationDefinition')?.[0];
          const mutation: OperationTypeNode = OperationTypeNode.MUTATION;
          if (definition?.kind == 'OperationDefinition' && definition?.operation === mutation) {
            operation.variables = omitDeep(operation.variables, '__typename');
            return forward(operation);
          }
          return forward(operation);
        });
        return {
          cache: new InMemoryCache(),
          link: removeTypeNameFromMutation.concat(httpLink.create({ uri: environment.backEndUrl })),
        };
      },
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
